// import data from "../mock/mock.json"
import { Category } from "../../components/Category";
import { filterExtensionsByCategory } from "../../utils/filterExtensions";
import { Extension } from "../../types";
import Head from "next/head";
import { getExtensions } from "../../utils/api";
import { filterExtensionsByCountryBlocked } from "../../utils/filterExtensionsByCountryBlocked";
import { useTranslation } from "react-i18next";
import { getLocalePaths } from "../../utils/i18n.utils";

export const getStaticPaths = async () => {
  const languagePaths = getLocalePaths()

  return {
    paths: languagePaths,
    fallback: "blocking"
  }
}

export const getStaticProps = async () => {

  const extensions = await getExtensions()
  const filterByCountryBlocked = filterExtensionsByCountryBlocked(extensions.apps)
  const filteredExtensions = filterExtensionsByCategory(filterByCountryBlocked)

  return {
    props: {
      filteredExtensions
    },
    revalidate: 60 * 15
  }
}

interface HomeProps {
  filteredExtensions: {
    reportes: Extension[],
    gestion: Extension[],
    relevamientos: Extension[],
    clima: Extension[],
    analisis: Extension[],
    "don mario exacto"?: Extension[]
  }
}

export default function Home(props: HomeProps) {
  const { filteredExtensions } = props

  const { t } = useTranslation()
  return <>
    <Head>
      <meta name="description" key="desc" content="Auravant Extensions Marketplace" />
      <meta property="og:locale" content={`ES_AR`} />
			<meta property="og:url" content={`https://marketplace.auravant.com/`}/>
			<meta property="og:type" content='product'/>
			<meta property="og:logo" content={`https://marketplace.auravant.com/_next/image?url=https%3A%2F%2Fwww.auravant.com%2Fwp-content%2Fuploads%2F2021%2F04%2FLogotipo-Auravant.png&w=256&q=75`}/>
			<meta property="og:description" content={`Auravant Extensions Marketplace`} />
    </Head>
    <main className="px-2 py-4 lg:px-16 flex flex-col gap-4">
      <Category title={t("categories.analisis")} href={2} extensions={filteredExtensions.analisis} />
      <Category title={t("categories.gestion")} href={3} extensions={filteredExtensions.gestion} />
      <Category title={t("categories.relevamientos")} href={4} extensions={filteredExtensions.relevamientos} />
      <Category title={t("categories.clima")} href={5} extensions={filteredExtensions.clima} />
      <Category title={t("categories.reportes")} href={6} extensions={filteredExtensions.reportes} />
    </main >
  </>

}
